import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './WhoCreated.module.scss';

export const WhoCreatedStepOneSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>
          Who <span>created</span>
        </div>
        <div className={styles.stepSection_2}>
          Transparen <br /> Terra?
        </div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        A group of enthusiasts in Switzerland created the TransparenTerra project. The idea of using
        innovative technologies to make the world more fair and trustworthy has driven developers to
        invent and create an advanced digital platform for consulting, investing, communication,
        training, promotion, environmentally-friendly trading, and shopping.
      </div>
    }
  />
);
